import { type HTMLAttributes } from 'react'
import { cn } from './cn'

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  rounded?: 'sm' | 'md' | 'lg' | 'pill' | 'full'
}

const radiusClasses = {
  sm:   'rounded-md',
  md:   'rounded-lg',
  lg:   'rounded-2xl',
  pill: 'rounded-pill',
  full: 'rounded-full',
}

export function Skeleton({ rounded = 'md', className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        'shimmer bg-surface-elevated',
        radiusClasses[rounded],
        className,
      )}
      {...rest}
    />
  )
}
